import ApplicationController from '../application_controller'

class WorkingTimeModelsController extends ApplicationController {
  static targets = ['flexibleCheckbox', 'coreCheckbox', 'fixedCheckbox', 'flexibleTimes', 'coreTimes', 'fixedTimes', 'fixedPresence']

  connect () {
    this.setVisibility(this.flexibleCheckboxTarget.checked, this.flexibleTimesTarget)
    this.setVisibility(!this.flexibleCheckboxTarget.checked, this.fixedTimesTarget)
    this.setVisibility(this.coreCheckboxTarget.checked, this.coreTimesTarget)
    this.setVisibility(this.fixedCheckboxTarget.checked, this.fixedPresenceTarget)

    this.addListeners(this.flexibleCheckboxTarget, this.flexibleTimesTarget)
    this.addListeners(this.flexibleCheckboxTarget, this.fixedTimesTarget, { negate: true })
    this.addListeners(this.coreCheckboxTarget, this.coreTimesTarget)
    this.addListeners(this.fixedCheckboxTarget, this.fixedPresenceTarget)

    this.coreCheckboxEnable()

    this.calculateTotalHours()
  }

  setVisibility (show, target) {
    if (show) {
      target.classList.remove('d-none')
    } else {
      target.classList.add('d-none')
    }
  }

  addListeners (checkbox, target, options = {}) {
    checkbox.addEventListener('change', (event) => {
      if (options.negate ? !event.target.checked : event.target.checked) {
        target.classList.remove('d-none')
      } else {
        target.classList.add('d-none')
      }
    })
  }

  coreCheckboxEnable () {
    const enableCore = (allowed) => {
      if (allowed) {
        this.coreCheckboxTarget.disabled = false
      } else {
        this.coreCheckboxTarget.disabled = true
        this.coreCheckboxTarget.checked = false
        this.setVisibility(false, this.coreTimesTarget)
      }
    }

    this.flexibleCheckboxTarget.addEventListener('change', (event) => {
      enableCore(event.target.checked)
    })

    enableCore(this.flexibleCheckboxTarget.checked)
  }

  calculateTotalHours () {
    const weeklyHoursInput = document.querySelector('#employees_working_time_model_weekly_hours')
    const dayInputs = document.querySelectorAll(".weekly-distribution input[type='number']")
    dayInputs.forEach(input => {
      input.addEventListener('change', () => {
        let total = 0.00
        dayInputs.forEach(input => {
          const value = parseFloat(input.value)
          if (value) total += parseFloat(input.value)
        })
        weeklyHoursInput.value = total.toFixed(2)
      })
    })
  }

  isAnyChecked () {
    return this.flexibleCheckboxTarget.checked || this.coreCheckboxTarget.checked || this.fixedCheckboxTarget.checked
  }
}

export default WorkingTimeModelsController
